import {
    tripSelectors,
} from 'wanderu-ducks-trips';
import { createAppSelector } from 'wanderu-ducks-utils';

const EMPTY_ITINERARIES = Object.freeze([]);

const selectItineraries = createAppSelector(
    [
        (state, tripIds) => {
            const legIds = tripSelectors.selectLegIds(state, tripIds);
            return legIds
                ? legIds.map((legId) => tripSelectors.selectTripItinerary(state, legId))
                : EMPTY_ITINERARIES;
        },
    ],
    (itineraries) => itineraries,
);

export {
    selectItineraries,
};
